import script from "./mixTester.vue?vue&type=script&lang=js"
export * from "./mixTester.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__